"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Operation_1 = require("./Operation");
var Overwrite_1 = require("./Overwrite");
var Path_1 = require("../util/Path");
var util_1 = require("@firebase/util");
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
 function Merge(
 /**@inheritDoc */ source, 
 /**@inheritDoc */ path, 
 /**@inheritDoc */ children) {
 this.source = source;
 this.path = path;
 this.children = children;
 /** @inheritDoc */
 this.type = Operation_1.OperationType.MERGE;
 }
 /**
 * @inheritDoc
 */
 Merge.prototype.operationForChild = function (childName) {
 if (this.path.isEmpty()) {
 var childTree = this.children.subtree(new Path_1.Path(childName));
 if (childTree.isEmpty()) {
 // This child is unaffected
 return null;
 }
 else if (childTree.value) {
 // We have a snapshot for the child in question. This becomes an overwrite of the child.
 return new Overwrite_1.Overwrite(this.source, Path_1.Path.Empty, childTree.value);
 }
 else {
 // This is a merge at a deeper level
 return new Merge(this.source, Path_1.Path.Empty, childTree);
 }
 }
 else {
 util_1.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
 return new Merge(this.source, this.path.popFront(), this.children);
 }
 };
 /**
 * @inheritDoc
 */
 Merge.prototype.toString = function () {
 return ('Operation(' +
 this.path +
 ': ' +
 this.source.toString() +
 ' merge: ' +
 this.children.toString() +
 ')');
 };
 return Merge;
}());
exports.Merge = Merge;

//# sourceMappingURL=Merge.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/operation/Merge.js
// module id = 89
// module chunks = 0